import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RxStompService } from '@stomp/ng2-stompjs';
import { Message } from '@stomp/stompjs';
import { environment } from 'environments/environment';

// Zenklub services.
import { EventsService } from './events.service';

@Injectable({
	providedIn: 'root',
})
export class IdWallService {
	constructor(
		private http: HttpClient,
		private events: EventsService,
		private rxStompService: RxStompService
	) {}

	public cpnjValidation(data) {
		const body = {
			businessFiscalId: data.businessFiscalId,
			fiscalId: data.fiscalId,
		};
		return this.http.put('professionals/profile/cnpjValidation', body);
	}

	public responseCnpjValidation(userId: string): void {
		const value = environment.rabbitmq.toppics.financial + userId;

		this.rxStompService.watch(value).subscribe((message: Message) => {
			this.events.verifyNewEvent(JSON.parse(message.body));
		});
	}

	public disconnect() {
		this.rxStompService.deactivate();
	}
}
